import React from 'react';
import { Facebook, Twitter, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#111111] text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Lincoln County Cardinals</h3>
            <p className="text-gray-400">
              Join us in our pursuit of baseball excellence in Lincoln County.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/schedule" className="text-gray-400 hover:text-white">Game Schedule</a></li>
              <li><a href="/players" className="text-gray-400 hover:text-white">Team Roster</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white">Join the Team</a></li>
              <li><a href="/shop" className="text-gray-400 hover:text-white">Team Shop</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Lincoln County Cardinals</li>
              <li>272 Gardiner Rd</li>
              <li>Wiscasset, ME 04578</li>
              <li>(207) 751-3271</li>
              <li>gobirds@lincolncountycardinals.com</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/people/Lincoln-County-Cardinals/61560770855925/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="https://www.instagram.com/lincolncountycards/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                <Instagram className="h-6 w-6" />
              </a>
              <a href="mailto:gobirds@lincolncountycardinals.com" className="text-gray-400 hover:text-white">
                <Mail className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Lincoln County Cardinals. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;